<!-- Mobile toolbar -->
<app-toolbar-mobile class="lg:hidden" (modelGalleryClicked)="modelGalleryClicked()" />

<!-- Desktop toolbar -->
<app-toolbar-desktop class="hidden lg:inline" (modelGalleryClicked)="modelGalleryClicked()" />
